import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useOnEnterOrSpacebar from 'hooks/useOnEnterOrSpacebar';
import Badge from 'components/consumer/Badge';
import BrandTooltip from 'components/consumer/BrandTooltip';
import MaterialThumbnail from 'components/consumer/MaterialThumbnail';
import InfoIcon from 'components/icons/IconInfoNew';
import { colorGrayLight2 } from 'styles/layout/colors';
import Placeholder from 'components/consumer/Placeholder';
import usePDPClearanceData from 'data-hooks/useClearanceData/usePDPClearanceData';
import usePDPBasicDetails from '../state/context/usePDPBasicDetails';
const hasBothWords = (str, firstWord, secondWord) => {
  if (!str) {
    return false;
  }
  const strLowerCase = str.toLowerCase();
  return strLowerCase.includes(firstWord) && strLowerCase.includes(secondWord);
};
const getStockQuantityToShow = (selectedOptionsStockQty, isDiningChair) => {
  if (selectedOptionsStockQty <= 5) {
    return selectedOptionsStockQty;
  }
  if (isDiningChair && selectedOptionsStockQty >= 12) {
    return 12;
  }
  return 5;
};
const PDPActiveFabric = t0 => {
  const $ = _c(35);
  const {
    isEditOrder: t1,
    isModularBundleProduct,
    isSelectedOptionsQuickship,
    loading,
    onClick,
    selectedOption,
    selectedOptionsStockQty,
    showAdditionalCost: t2,
    showInfoIcon: t3,
    size: t4,
    materialNameClass: t5,
    fullHeight: t6,
    className: t7
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const showAdditionalCost = t2 === undefined ? true : t2;
  const showInfoIcon = t3 === undefined ? true : t3;
  const size = t4 === undefined ? "md" : t4;
  const materialNameClass = t5 === undefined ? "" : t5;
  const fullHeight = t6 === undefined ? false : t6;
  const className = t7 === undefined ? "" : t7;
  const {
    data: basicDetailsData
  } = usePDPBasicDetails();
  const {
    type
  } = basicDetailsData ?? {};
  const isDiningChair = hasBothWords(type?.name, "dining", "chair");
  const {
    data: t8
  } = usePDPClearanceData();
  const {
    isClearance,
    isFlashSale
  } = t8;
  const activeFabricRef = useRef(null);
  useOnEnterOrSpacebar(!!onClick, activeFabricRef, onClick);
  const showFinalSale = !isFlashSale && isClearance;
  if (loading) {
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div className="flex justify-start"><Placeholder type="rect" loading={true} className="mb-2 lg:mb-1.5" style={{
          height: "23px",
          width: "175px"
        }} /></div>;
      $[0] = t9;
    } else {
      t9 = $[0];
    }
    return t9;
  }
  if (!selectedOption) {
    return null;
  }
  const label = `More information about ${selectedOption.label || selectedOption.value}`;
  const formattedAddlCost = _temp;
  const t9 = "flex justify-start";
  const t10 = `flex items-center pr-0.5 border-2 border-solid border-transparent focus-visible:border-brand focus-visible:border-radius-2xl focus-visible:rounded focus-visible:outline-none mb-2 lg:mb-1.5 ${className}`;
  const t11 = onClick ? "button" : undefined;
  const t12 = onClick ? "0" : undefined;
  const t13 = selectedOption.label || selectedOption.value;
  let t14;
  if ($[1] !== fullHeight || $[2] !== selectedOption.description || $[3] !== selectedOption.image || $[4] !== selectedOption.materialId || $[5] !== selectedOption.upholsteryOptionId || $[6] !== t13) {
    t14 = <div className="w-4 h-4 mr-1"><MaterialThumbnail image={selectedOption.image} label={t13} materialId={selectedOption.materialId} upholsteryOptionId={selectedOption.upholsteryOptionId} description={selectedOption.description} isRound={true} fullHeightThumbnail={fullHeight} /></div>;
    $[1] = fullHeight;
    $[2] = selectedOption.description;
    $[3] = selectedOption.image;
    $[4] = selectedOption.materialId;
    $[5] = selectedOption.upholsteryOptionId;
    $[6] = t13;
    $[7] = t14;
  } else {
    t14 = $[7];
  }
  const t15 = "mx-1 leading-4 [&_*]:inline [&_*]:leading-4";
  const t16 = `hover:underline font-bold ${materialNameClass}`;
  const t17 = size === "xs";
  const t18 = size === "sm";
  const t19 = size === "md";
  const t20 = !materialNameClass;
  let t21;
  if ($[8] !== t16 || $[9] !== t17 || $[10] !== t18 || $[11] !== t19 || $[12] !== t20) {
    t21 = classNames(t16, {
      "text-xs": t17,
      "text-sm": t18,
      "text-base": t19,
      inline: t20
    });
    $[8] = t16;
    $[9] = t17;
    $[10] = t18;
    $[11] = t19;
    $[12] = t20;
    $[13] = t21;
  } else {
    t21 = $[13];
  }
  const t22 = selectedOption.label || selectedOption.value;
  const t23 = selectedOption.exclude_from_sale ? " - Limited Edition" : null;
  let t24;
  if ($[14] !== t21 || $[15] !== t22 || $[16] !== t23) {
    t24 = <h3 data-xc="PDPActiveFabric-name" className={t21}>{t22}{t23}</h3>;
    $[14] = t21;
    $[15] = t22;
    $[16] = t23;
    $[17] = t24;
  } else {
    t24 = $[17];
  }
  const t25 = selectedOption?.additionalCost && showAdditionalCost ? <span className={classNames("font-bold flex items-center", {
    "text-xs": size === "xs",
    "text-sm": size === "sm",
    "text-base": size === "md"
  })}>{"  ("}{isEditOrder && selectedOption?.origAddlCost && selectedOption.origAddlCost !== selectedOption.additionalCost && <span className="line-through text-xs px-0.5">{formattedAddlCost(selectedOption?.origAddlCost)}</span>}<span className={classNames("font-bold text-xs", {
      "text-red": isEditOrder
    })}>{formattedAddlCost(selectedOption?.additionalCost)}{isModularBundleProduct ? "/piece" : ""}</span>)</span> : isSelectedOptionsQuickship && selectedOptionsStockQty ? <span className="text-red text-xs font-bold ml-1.5"><span className="mr-1.5">•</span><span>{`Only ${getStockQuantityToShow(selectedOptionsStockQty, isDiningChair)} left!`}</span></span> : null;
  let t26;
  if ($[18] !== showInfoIcon) {
    t26 = showInfoIcon && <> <InfoIcon className="cursor-pointer" color={colorGrayLight2} height={13} width={13} aria-hidden="true" /></>;
    $[18] = showInfoIcon;
    $[19] = t26;
  } else {
    t26 = $[19];
  }
  let t27;
  if ($[20] !== showFinalSale) {
    t27 = showFinalSale && <BrandTooltip inactiveOnMobile={true} showInfoIcon={false} customIcon={<Badge className="w-fit bg-yellow-light px-2"><span className="text-gray">Final Sale</span></Badge>} arrowOffset={32}>{"This final sale product is eligible for cancellation within 24 hours of order placement. Ineligible for returns except for items arriving damaged & documented by carrier. Ineligible for warranty claims unless reports of defects are submitted within 14 days of delivery, cosmetic damage isn't covered."}</BrandTooltip>;
    $[20] = showFinalSale;
    $[21] = t27;
  } else {
    t27 = $[21];
  }
  let t28;
  if ($[22] !== t24 || $[23] !== t25 || $[24] !== t26 || $[25] !== t27) {
    t28 = <div className={t15}>{t24}{t25}{t26}{t27}</div>;
    $[22] = t24;
    $[23] = t25;
    $[24] = t26;
    $[25] = t27;
    $[26] = t28;
  } else {
    t28 = $[26];
  }
  let t29;
  if ($[27] !== label || $[28] !== onClick || $[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t14 || $[33] !== t28) {
    t29 = <div className={t9}><div className={t10} onClick={onClick} role={t11} tabIndex={t12} aria-label={label} title={label} ref={activeFabricRef}>{t14}{t28}</div></div>;
    $[27] = label;
    $[28] = onClick;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
    $[32] = t14;
    $[33] = t28;
    $[34] = t29;
  } else {
    t29 = $[34];
  }
  return t29;
};
PDPActiveFabric.propTypes = {
  isEditOrder: PropTypes.bool,
  isModularBundleProduct: PropTypes.bool,
  isSelectedOptionsQuickship: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  selectedOption: PropTypes.shape({
    exclude_from_sale: PropTypes.bool,
    additionalCost: PropTypes.number,
    description: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string,
    materialId: PropTypes.number,
    origAddlCost: PropTypes.number,
    upholsteryOptionId: PropTypes.number,
    value: PropTypes.string,
    sku: PropTypes.string
  }),
  selectedOptionsStockQty: PropTypes.number,
  showAdditionalCost: PropTypes.bool,
  showInfoIcon: PropTypes.bool,
  materialNameClass: PropTypes.string,
  fullHeight: PropTypes.bool,
  className: PropTypes.string
};
export default PDPActiveFabric;
function _temp(cost) {
  return cost < 0 ? `-$${cost * -1}` : `$${cost}`;
}